export default __webpack_public_path__ + "static/media/ambient-bright-purple-red.f3735249.jpg";